import { VerificationSchemaView } from "../../slices/types";
import { FC, ReactNode } from "react";
import { VerticalSpacer } from "./VerticalSpacer";
import { tabTitle } from "../../utils";
import { ApplicantType } from "shared/types";
import { cx } from "shared/utils";
import { Show } from "shared/components";

/**
 * isLastChild: true/false means it's a child, undefined means it's a parent or has no children.
 */
interface Props {
  tabName: VerificationSchemaView | ApplicantType;
  onClick: (v: VerificationSchemaView | ApplicantType) => void;
  Icon?: ReactNode;
  selectedTab?: VerificationSchemaView | ApplicantType;
  selectedChild?: ApplicantType;
  disabled?: boolean;
  disabledMessage?: string;
  childItems?: ApplicantType[];
  isLastChild?: boolean;
  active?: boolean;
}

export const LeftPane: FC<Props> = ({
  tabName,
  onClick,
  Icon,
  selectedTab,
  selectedChild,
  disabled,
  disabledMessage,
  childItems,
  isLastChild,
  active
}) => {
  const isActive = (active || selectedTab === tabName) && !childItems;
  return (
    <div className="space-y-1">
      <div
        className={cx(
          "flex items-center gap-2 rounded-lg text-sm font-medium text-content-1000 transition-all",
          childItems ? "" : !isActive ? "hover:bg-alpha-40 cursor-pointer" : "",
          isActive ? "bg-primary-20 text-primary-600" : "",
          disabled ? "group relative opacity-40 hover:opacity-100" : "",
          isLastChild === undefined ? "p-3" : ""
        )}
        onClick={!disabled && !childItems ? () => onClick(tabName) : undefined}
      >
        {Icon ? Icon : null}
        {isLastChild !== undefined ? (
          <div className="h-11 flex items-center">
            <VerticalSpacer isLast={isLastChild} isActive={isActive} />
          </div>
        ) : null}
        <p className="truncate">{tabTitle[tabName]}</p>
        <Show if={disabled}>
          <span className="invisible absolute min-w-[228px] translate-y-10 transform rounded-xl bg-alpha-800 p-4 text-sm text-content-1000-inverted group-hover:visible">
            {disabledMessage}
          </span>
        </Show>
      </div>
      {childItems ? (
        <div>
          {childItems.map((childItem, idx) => (
            <LeftPane
              key={childItem}
              tabName={childItem}
              selectedTab={
                active || selectedTab === tabName ? selectedChild : undefined
              }
              onClick={() => onClick(childItem)}
              isLastChild={idx === childItems.length - 1}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
